export default {
  meta: {
    title: '应用管理'
  }
};
